import { useEffect } from "react";
import { holdLoader } from "../../helpers/apiQueue";

// Doesn't render anything itself: while mounted it keeps the single app-wide
// loader (GlobalApiLoader) visible, so loaders never stack on top of each other.
const Loader = () => {
  useEffect(() => holdLoader(), []);
  return null;
};

export default Loader;
